import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import { RegistrationSetup } from '@/interfaces/registration/RegistrationSetup';
import { FormConfigurationField } from '@/interfaces/registration/fields/FormConfigurationField';
import lodash from 'lodash';
import { namespace } from 'vuex-class';
const registration = namespace('registration');

@Component
export default class FieldMixin extends Vue {
  @registration.State
  public registrationSetup!: RegistrationSetup;

  @registration.State
  public registrationData!: RegistrationData;

  public getField (fieldType: string): FormConfigurationField | undefined {
    return lodash.find(this.registrationData.formConfig?.fields, { fieldType: fieldType });
  }

  public isRequired (fieldType: string): boolean {
    const field = this.getField(fieldType);
    return field !== undefined && field.fieldBehaviour === 'Required';
  }

  public isHidden (fieldType: string): boolean {
    const field = this.getField(fieldType);
    return field !== undefined && field.fieldBehaviour === 'Hidden';
  }

  public isOptional (fieldType: string): boolean {
    const field = this.getField(fieldType);
    return field !== undefined && field.fieldBehaviour === 'Optional';
  }

  public getCustomHelpText (fieldType: string): string | undefined {
    const field = this.getField(fieldType);
    return field?.customHelpText;
  }

  public getCustomLabel (fieldType: string): string | undefined {
    const field = this.getField(fieldType);
    return field?.customLabel;
  }
}
